<template>
  <div class="HomeworkTecDetail">
    <div class="header">
      <el-row :gutter="1" type="flex">
        <el-col :span="10"
          ><span class="title">统计日期:</span>
          <datePicker
            :value="{
              startDate: searchForm.startDate,
              endDate: searchForm.endDate
            }"
            @dateValue="dateValue"
          />
        </el-col>
        <el-col :span="7">
          <span class="title">省市区:</span
          ><el-cascader
            :options="options"
            :props="{ multiple: true }"
            collapse-tags
            clearable
            v-model="cityValue"
            @change="cityChange"
            @visible-change="cityVisible"
            @remove-tag="removeTag"
          ></el-cascader>
        </el-col>
        <el-col :span="7"
          ><span class="title">学校:</span
          ><filterSelect
            ref="filterSelect1"
            :optionsList="schoolList"
            :defaultChecked="defaultSchool"
            @checked="schoolChecked"
        /></el-col>
      </el-row>
      <el-row :gutter="1" type="flex">
        <el-col :span="10">
          <span class="title">教师名称:</span
          ><filterSelect
            ref="filterSelect2"
            placeholder="请输入教师名称"
            :optionsList="tecList"
            @checked="tecChecked"
          />
          <el-button style="margin-left: 5px" size="small" @click="reset">重置</el-button>
          <el-button type="primary" size="small" @click="search">查询</el-button>
        </el-col>
        <el-col :span="3"><div class=""></div></el-col>
      </el-row>
    </div>
    <div class="content">
      <div class="hint">
        <div class="left">
          教师明细({{ activeName }})
          <el-popover
            placement="bottom-start"
            width="400"
            trigger="hover"
            :visible-arrow="false"
            popper-class="popper-hint"
          >
            <div v-if="activeName == '平台作业'" v-html="JSMXPTZY"></div>
            <div v-else v-html="JSMXAIZNK"></div>
            <i class="el-icon-info" slot="reference"></i>
          </el-popover>
        </div>
        <div class="right">
          <el-button type="primary" size="small" @click="downExcel" :loading="downLoading">导出数据</el-button>
        </div>
      </div>
      <div class="table">
        <!-- 平台作业 -->
        <el-table
          v-if="!emptyIsShow && activeName == '平台作业'"
          :data="tableDataHomework"
          :key="keytable1"
          ref="table1"
          border
          size="small"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
          stripe
          height="100%"
          @sort-change="sortChange"
          v-loading="loading"
          :default-sort="{ prop: 'hteClassPublishNum', order: 'descending' }"
        >
          <el-table-column fixed type="index" label="排名" width="80">
            <template slot-scope="scope">
              <span>{{ (searchForm.pageNum - 1) * searchForm.pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed prop="teacherName" label="教师名称" width="100"> </el-table-column>
          <el-table-column fixed prop="schoolName" label="学校名称" width="220"> </el-table-column>
          <el-table-column sortable="custom" prop="hteClassPublishNum" label="布置班级作业次数" width="150">
          </el-table-column>
          <el-table-column sortable="custom" prop="hteClassPublishCopies" label="布置班级作业份数" width="150">
          </el-table-column>
          <el-table-column sortable="custom" prop="hteClassCollectNum" label="收集班级作业次数" width="150">
          </el-table-column>
          <el-table-column sortable="custom" prop="hteClassCollectCopies" label="收集班级作业份数" width="150">
          </el-table-column>
          <el-table-column sortable="custom" prop="hteTargetPublishNum" label="布置靶向作业次数" width="150">
          </el-table-column>
          <el-table-column sortable="custom" prop="hteTargetPublishCopies" label="布置靶向作业份数" width="150">
          </el-table-column>
          <el-table-column sortable="custom" prop="hteTargetCollectNum" label="收集靶向作业次数" width="150">
          </el-table-column>
          <el-table-column sortable="custom" prop="hteTargetCollectCopies" label="收集靶向作业份数" width="150">
          </el-table-column>
          <el-table-column sortable="custom" prop="hteLayeredPublishNum" label="布置分层作业次数" width="150">
          </el-table-column>
          <el-table-column sortable="custom" prop="hteLayeredPublishCopies" label="布置分层作业份数" width="150">
          </el-table-column>
          <el-table-column sortable="custom" prop="hteLayeredCollectNum" label="收集分层作业次数" width="150">
          </el-table-column>
          <el-table-column sortable="custom" prop="hteLayeredCollectCopies" label="收集分层作业份数" width="150">
          </el-table-column>
          <el-table-column sortable="custom" prop="speakHteNum" label="讲解作业数" width="150"> </el-table-column>
        </el-table>
        <!-- AI智能卡 -->
        <el-table
          v-if="!emptyIsShow && activeName == 'AI智能卡'"
          :data="tableDataAi"
          :key="keytable2"
          ref="table2"
          border
          size="small"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
          stripe
          height="100%"
          @sort-change="sortChange"
          :default-sort="{ prop: 'hteCollectNum', order: 'descending' }"
          v-loading="loading"
        >
          <el-table-column fixed type="index" label="排名">
            <template slot-scope="scope">
              <span>{{ (searchForm.pageNum - 1) * searchForm.pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed prop="teacherName" label="教师名称"> </el-table-column>
          <el-table-column fixed prop="schoolName" label="学校名称" width="220"> </el-table-column>
          <el-table-column sortable="custom" prop="hteCollectNum" label="采集AI智能卡次数"> </el-table-column>
          <el-table-column sortable="custom" prop="htePCollectCopies" label="采集AI智能卡份数"> </el-table-column>
          <el-table-column sortable="custom" prop="speakHteNum" label="讲解AI智能卡次数"> </el-table-column>
        </el-table>
        <el-empty v-if="emptyIsShow" description="暂无数据" :image-size="80" style="margin-top: 100px"></el-empty>
      </div>
      <div class="pagSize" v-if="!emptyIsShow">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="searchForm.pageSize"
          :current-page.sync="searchForm.pageNum"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import filterSelect from '../../components/FilterSelect/index.vue'
import datePicker from '../../components/datePicker/index.vue'
// import newDate from "../../components/newDate";
import { JSMXPTZY, JSMXAIZNK } from '@/utils/explainText.js'
import { lastWeek } from '@/utils/date.js'
// import { saveAs } from 'file-saver'
import fileSave from '@/utils/fileSave.js'

import { homeworkDetail, AIDetail } from '@/api/modules/excelApi.js'
import { generateTableParms, getToken, excelName } from '@/utils/index.js'
import { resize } from '@/mixins/resize.js'
export default {
  name: 'HomeworkTecDetail',
  mixins: [resize],
  components: {
    filterSelect,
    // newDate,
    datePicker
  },
  data() {
    return {
      JSMXPTZY: JSMXPTZY,
      JSMXAIZNK: JSMXAIZNK,
      activeName: '',
      schoolList: JSON.parse(sessionStorage.getItem('schoolList')),
      tecList: [],
      tableDataHomework: [],
      tableDataAi: [],
      searchForm: {
        startDate: lastWeek().startOf,
        endDate: lastWeek().endOf,
        loginUserId: JSON.parse(sessionStorage.getItem('userInfo')).Key,
        schoolIds: [],
        pageSize: 12,
        pageNum: 1,
        teacherIds: [],
        provinceIds: [],
        cityIds: [],
        localeIds: [],
        ascOrDes: false,
        sortCode: ''
      },
      loading: false,
      total: 0,
      options: JSON.parse(sessionStorage.getItem('cityList')),
      emptyIsShow: false,
      address: {
        provinceIds: [],
        cityIds: [],
        localeIds: [],
        loginUserId: JSON.parse(sessionStorage.getItem('userInfo')).Key
      },
      cityValue: [],
      keytable1: 0,
      keytable2: 0,
      defaultSchool: [],
      downLoading: false
    }
  },
  created() {
    this.$store.commit('SET_ISBACK', true)
    let info = this.$route.query
    this.activeName = info.activeName
    this.searchForm.startDate = info.startDate
    this.searchForm.endDate = info.endDate
    this.searchForm.schoolIds.push(info.schoolId)
    this.defaultSchool.push(this.schoolList[this.schoolList.findIndex((el) => el.value == info.schoolId)])
    console.log(this.defaultSchool)
    if (this.activeName == 'AI智能卡') {
      this.searchForm.sortCode = 'hteCollectNum'
      this.aiGetList()
    } else if (this.activeName == '平台作业') {
      this.searchForm.sortCode = 'hteClassPublishNum'
      this.homeworkGetList()
    }
  },
  mounted() {
    this.getTecs()
  },
  destroyed() {
    this.$store.commit('SET_ISBACK', false)
  },
  methods: {
    // 表格重绘
    tableLayout() {
      // console.log('组件方法');
      if (this.activeName == 'AI智能卡') {
        this.$refs.table2.doLayout()
      } else if (this.activeName == '平台作业') {
        this.$refs.table1.doLayout()
      }
    },
    // date组件事件
    dateValue(v) {
      this.searchForm.startDate = v.startDate
      this.searchForm.endDate = v.endDate
    },
    //学校选择组件事件
    schoolChecked(v) {
      // console.log(v, "schoolChecked");
      this.searchForm.schoolIds = []
      // this.searchForm.teacherIds = [];
      v.forEach((el) => {
        this.searchForm.schoolIds.push(el.value)
      })
      this.getTecs()
    },
    // 教师选择组件事件
    tecChecked(v) {
      this.searchForm.teacherIds = []
      v.forEach((el) => {
        this.searchForm.teacherIds.push(el.value)
      })
    },
    //重置
    reset() {
      this.$refs.filterSelect1.checkedValue = this.defaultSchool[0].label
      this.$refs.filterSelect2.checkedValue = ''
      this.searchForm = this.$options.data().searchForm
      this.searchForm.startDate = this.$route.query.startDate
      this.searchForm.endDate = this.$route.query.endDate
      this.searchForm.schoolIds.push(this.$route.query.schoolId)
      this.address = this.$options.data().address
      this.schoolList = JSON.parse(sessionStorage.getItem('schoolList'))
      this.cityValue = []
      if (this.activeName == 'AI智能卡') {
        this.keytable2 += 1
        this.searchForm.sortCode = 'hteCollectNum'
        this.aiGetList()
      } else if (this.activeName == '平台作业') {
        this.keytable1 += 1
        this.searchForm.sortCode = 'hteClassPublishNum'
        this.homeworkGetList()
      }
      this.getTecs()
    },
    // 查询
    search() {
      this.searchForm.pageNum = 1
      if (this.activeName == 'AI智能卡') {
        this.aiGetList()
      } else if (this.activeName == '平台作业') {
        this.homeworkGetList()
      }
    },
    // 排序
    sortChange({ column, prop, order }) {
      this.searchForm.sortCode = prop
      if (order !== null) {
        order == 'descending' ? (this.searchForm.ascOrDes = false) : (this.searchForm.ascOrDes = true)
        if (this.activeName == 'AI智能卡') {
          this.aiGetList()
        } else if (this.activeName == '平台作业') {
          this.homeworkGetList()
        }
      }
    },
    // 省市区选择器
    cityChange(v) {
      this.address = this.$options.data().address
      if (v.length < 1) {
        this.searchForm.provinceIds = this.searchForm.cityIds = this.searchForm.localeIds = []
        this.getSchools()
        this.getTecs()
        return
      }
      v.forEach((el) => {
        this.address.provinceIds.push(el[0])
        this.address.cityIds.push(el[1])
        this.address.localeIds.push(el[2])
        this.searchForm.provinceIds = this.address.provinceIds
        this.searchForm.cityIds = this.address.cityIds
        this.searchForm.localeIds = this.address.localeIds
      })
      // this.searchForm.schoolIds = this.searchForm.teacherIds = []
    },
    removeTag(v) {
      // console.log(v);
      let i = this.address.provinceIds.findIndex((el) => el == v[0])
      this.address.provinceIds.splice(i, 1)
      this.address.cityIds.splice(i, 1)
      this.address.localeIds.splice(i, 1)
      if (this.address.provinceIds.length > 0) {
        // this.searchForm.schoolIds = this.searchForm.teacherIds = []
        // console.log("111");
        this.getSchools()
        this.getTecs()
      }
    },
    // 省市区选择器收起时
    cityVisible(v) {
      // console.log(v);
      if (!v && this.address.provinceIds.length > 0) {
        // console.log("请求");
        this.getSchools()
        this.getTecs()
      }
    },
    getSchools() {
      this.$refs.filterSelect1.checkedValue = ''
      this.searchForm.schoolIds = []
      this.$API.basicsApi.getSchoolList(this.address).then((res) => {
        // console.log(res);
        // this.$refs.filterSelect1.uncertainCheckedList = [];
        this.schoolList = res.result.map((el) => {
          el.label = el.schoolName
          el.value = el.schoolId
          delete el.schoolId
          delete el.schoolName
          delete el.total
          return el
        })
      })
    },
    getTecs() {
      let obj = {
        loginUserId: this.searchForm.loginUserId,
        schoolIds: this.searchForm.schoolIds,
        ...this.address
      }
      this.$refs.filterSelect2.checkedValue = ''
      this.searchForm.teacherIds = []
      this.$API.basicsApi.getTecList(obj).then((res) => {
        // console.log(res, "tec");
        this.tecList = res.result.map((el) => {
          el.label = el.teaName
          el.value = el.teaId
          delete el.teaName
          delete el.teaId
          return el
        })
        // console.log(this.tecList);
      })
    },
    // 获取列表
    homeworkGetList() {
      this.loading = true
      this.$API.homeworkAnalysisApi
        .homeworkDetail(this.searchForm)
        .then((res) => {
          // console.log(res);
          // console.log(this.tableDataHomework);
          this.tableDataHomework = res.result
          // console.log(this.tableDataHomework);
          if (this.tableDataHomework.length > 0) {
            this.emptyIsShow = false
            this.total = this.tableDataHomework[0].total
          } else {
            this.total = 0
            this.emptyIsShow = true
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // AI智能卡教师详情
    aiGetList() {
      this.loading = true
      this.$API.homeworkAnalysisApi
        .aiDetail(this.searchForm)
        .then((res) => {
          // console.log(res);
          this.tableDataAi = res.result
          if (this.tableDataAi.length > 0) {
            this.emptyIsShow = false
            this.total = this.tableDataAi[0].total
          } else {
            this.total = 0
            this.emptyIsShow = true
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleSizeChange(v) {},
    //点击页码
    handleCurrentChange(v) {
      this.searchForm.pageNum = v
      if (this.activeName == 'AI智能卡') {
        this.aiGetList()
      } else if (this.activeName == '平台作业') {
        this.homeworkGetList()
      }
    },
    // 导出数据
    downExcel() {
      this.downLoading = true

      let obj = {
        fileName: '',
        ...this.searchForm,
        ...getToken()
      }
      delete obj.pageSize
      delete obj.pageNum
      if (this.activeName == 'AI智能卡') {
        obj.fileName = excelName('教师AI智能卡使用分析', obj.startDate, obj.endDate)
        fileSave(AIDetail + generateTableParms(obj), obj.fileName + '.xlsx').then(() => {
          this.downLoading = false
        })
      } else if (this.activeName == '平台作业') {
        obj.fileName = excelName('教师平台作业使用分析', obj.startDate, obj.endDate)
        fileSave(homeworkDetail + generateTableParms(obj), obj.fileName + '.xlsx').then(() => {
          this.downLoading = false
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.HomeworkTecDetail {
  @include myMain();
  .header {
    @include myHeader();
  }
  .content {
    @include myContent();
    .hint {
      @include myContent-hint();
    }
    .table {
      @include myTable();
    }
    .pagSize {
      @include myPagSize();
    }
  }
}
</style>
